"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageCarousel = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _react = require("react");

var _reactImageFallback = _interopRequireDefault(require("react-image-fallback"));

var _Spinner = _interopRequireDefault(require("../../../assets/images/Icons/Spinner.gif"));

var _ArrowBackIos = _interopRequireDefault(require("@mui/icons-material/ArrowBackIos"));

var _defaultProductImage = _interopRequireDefault(require("../../../assets/images/defaultImages/defaultProductImage.png"));

var _jsxRuntime = require("react/jsx-runtime");

var ImageCarousel = function ImageCarousel(_ref) {
  var _ref$imageArray = _ref.imageArray,
      imageArray = _ref$imageArray === void 0 ? [] : _ref$imageArray;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      currentIndex = _useState2[0],
      setCurrentIndex = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      transitioning = _useState4[0],
      setTransitioning = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      isHover = _useState6[0],
      setIsHover = _useState6[1];

  var goToNextSlide = function goToNextSlide() {
    if (!transitioning) {
      setTransitioning(true);
      setCurrentIndex(function (prevIndex) {
        return (prevIndex + 1) % imageArray.length;
      });
      setTimeout(function () {
        setTransitioning(false);
      }, 500); // Adjust the transition duration to match your CSS
    }
  };

  var goToPrevSlide = function goToPrevSlide() {
    if (!transitioning) {
      setTransitioning(true);
      setCurrentIndex(function (prevIndex) {
        return (prevIndex - 1 + imageArray.length) % imageArray.length;
      });
      setTimeout(function () {
        setTransitioning(false);
      }, 500); // Adjust the transition duration to match your CSS
    }
  }; // useEffect(() => {
  //   const delay = 0;
  //   let repeat;
  //   setTimeout(() => {
  //     repeat = setInterval(() => {
  //       if (!isHover && imageArray.length > 1) goToNextSlide();
  //     }, 10000);
  //   }, delay);
  //   return () => {
  //     clearInterval(repeat);
  //   };
  // }, [isHover]);


  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container // onMouseEnter={() => setIsHover(true)}
  // onMouseLeave={() => setIsHover(false)}
  , {
    children: [imageArray.length > 1 && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      className: "prev",
      onClick: function onClick(e) {
        e.stopPropagation();
        goToPrevSlide();
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ArrowBackIos.default, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "slide-container",
      children: imageArray.length ? imageArray.map(function (img, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "image-container slide ".concat(index === currentIndex ? "active" : ""),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactImageFallback.default, {
            src: "https://".concat(process.env.REACT_APP_IMAGES_BUCKET, ".s3.amazonaws.com/").concat(img.src),
            fallbackImage: _Spinner.default,
            alt: img === null || img === void 0 ? void 0 : img.name,
            style: {
              transform: "translateX(-".concat(currentIndex * 100, "%)")
            }
          }, index)
        }, index);
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        src: _defaultProductImage.default,
        alt: "not image"
      })
    }), imageArray.length > 1 && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      className: "next",
      onClick: function onClick(e) {
        e.stopPropagation();
        goToNextSlide();
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ArrowBackIos.default, {})
    })]
  });
};

exports.ImageCarousel = ImageCarousel;